import React, { useEffect, useId, useState } from 'react';
import classnames from 'classnames';

import Show from 'components/Show';
import { minutesToParts, partsToMinutes } from 'utils/Helpers';

const Duration = ({ label, name, value, onChange, className, inputClassName }) => {
	// Generate random id once
	const id = useId();

	// Store parts from duration value
	const [duration, setDuration] = useState({
		days: '',
		hours: '',
		minutes: '',
		edited: false,
		initialized: false
	});

	// Container's classnames
	const containerClassName = classnames(
		'flex flex-col',
		className
	);

	// Input's classnames
	const elementClassName = classnames(
		'h-9 px-4 max-w-full flex justify-between items-center overflow-hidden bg-transparent border border-neutral-200 dark:border-neutral-700 dark:text-white text-neutral-800 placeholder:text-neutral-400 rounded-lg focus-within:border-transparent focus-within:ring focus-within:ring-amber-500 transition-all',
		inputClassName
	);

	// Handle input's value change
	const handle = (event) => {
		const part = event.target.name;
		const val = event.target.value;

		// Do not allow input other than empty string or number
		if (val !== '' && isNaN(Number(val))) return;

		// Do not allow to input < 0 days
		if (part === 'days' && val < 0) return;

		// Do not allow to input > 23 hours
		if (part === 'hours' && (val < 0 || val > 23)) return;

		// Do not allow to input > 59 minutes
		if (part === 'minutes' && (val < 0 || val > 59)) return;

		// Update fields value
		setDuration(prev => ({
			...prev,
			[part]: event.target.value,
			edited: true
		}));
	};

	// Update parent's value
	useEffect(() => {
		if (duration.edited) onChange({
			name,
			value: partsToMinutes(duration)
		});
	}, [duration]);

	// Initialize value
	useEffect(() => {
		if (!duration.initialized && value) {
			setDuration(prev => ({
				...prev,
				...minutesToParts(value),
				initialized: true
			}));
		}
	}, [duration, value]);

	return (
		<div className={containerClassName}>
			{/* Show label only if passed */}
			<Show if={label}>
				<label
					htmlFor={id}
					className="mb-1 text-sm font-bold text-neutral-800 dark:text-white transition-colors"
				>
					{label}
				</label>
			</Show>

			<div className={elementClassName}>
				<input
					id={id}
					type="text"
					name="days"
					min="0"
					max="99"
					placeholder="d"
					value={duration.days}
					onChange={handle}
					className="appearance-none bg-transparent w-1/4 h-full text-center"
				/>

				<span>:</span>

				<input
					type="text"
					name="hours"
					min="0"
					max="23"
					placeholder="h"
					value={duration.hours}
					onChange={handle}
					className="appearance-none bg-transparent w-1/4 h-full text-center"
				/>

				<span>:</span>

				<input
					type="text"
					name="minutes"
					min="0"
					max="59"
					placeholder="m"
					value={duration.minutes}
					onChange={handle}
					className="appearance-none bg-transparent w-1/4 h-full text-center"
				/>
			</div>
		</div>
	);
};

export default Duration;